import { create } from 'zustand';

type ChatBottomElementStoreState = {
  chatBottomElement: HTMLDivElement | null;
};

type ChatBottomElementStoreStateActions = {
  setChatBottomElement: (chatBottomElement: HTMLDivElement | null) => void;
};

const initialState: ChatBottomElementStoreState = {
  chatBottomElement: null
};

export const useChatBottomElementStore = create<ChatBottomElementStoreState & ChatBottomElementStoreStateActions>(
  set => ({
    ...initialState,
    setChatBottomElement: (chatBottomElement: HTMLDivElement | null) => set({ chatBottomElement })
  })
);
